import { Box, Flex, Icon } from '@chakra-ui/react';
import { ChevronUp, Settings as SettingsIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import Content from '../../components/content';
import { useFeatureFlag } from '@/providers/feature-flag-provider';
import { useGuard } from '@/hooks/useGuard';

const links: Array<{ label: string; to: string }> = [
    {
        label: 'Physicians',
        to: '/settings/physicians',
    },
    {
        label: 'Pharmacies',
        to: '/settings/pharmacies',
    },
    {
        label: 'Medications',
        to: '/settings/medications',
    },
    {
        label: 'Visit Types',
        to: '/settings/visit-types',
    },
    {
        label: 'Templates',
        to: '/settings/templates',
    },
    {
        label: 'Payroll Schedules',
        to: '/settings/payroll-schedules',
    },
    {
        label: 'Insurance Configuration',
        to: '/settings/insurance-config',
    },
];

export function Settings() {
    const { isEnabled } = useFeatureFlag();
    const hasReportAccess = useGuard('report:read');
    const hasComplianceAccess = useGuard('compliance:update');

    if (isEnabled('report-feature-flag')) {
        if (hasReportAccess) {
            if (!links.some((l) => l.label === 'Report Configuration')) {
                links.push({
                    label: 'Report Configuration',
                    to: '/settings/report-config',
                });
            }
        }
    }

    if (hasComplianceAccess) {
        if (!links.some((l) => l.label === 'Document Types')) {
            links.push({
                label: 'Document Types',
                to: '/settings/document-types',
            });
        }
    }

    return (
        <Content headerTitle="settings" headerIcon={<SettingsIcon size="20" />}>
            {{
                content: links.map((link) => (
                    <Link key={link.to} to={link.to}>
                        <Box py="3" px="4" borderBottomWidth="1px" borderColor={{ base: 'musa.light.border', _dark: 'musa.dark.border' }}>
                            <Flex justifyContent="between" width="100%">
                                <Box width="100%">{link.label}</Box>

                                <Box>
                                    <Icon
                                        boxSize={6}
                                        transform="rotate(90deg)"
                                        _hover={{
                                            cursor: 'pointer',
                                        }}>
                                        <ChevronUp />
                                    </Icon>
                                </Box>
                            </Flex>
                        </Box>
                    </Link>
                )),
            }}
        </Content>
    );
}
